<b3-modal
  [open]="open"
  overlay
  size="md"
  (b3-close)="close()">
  <b3-modal-header
    *ngIf="title"
    [heading]="title"
    aria-level="2"
    [icon]="headerIcon"
    [attr.icon-tone]="headerIconTone"
    [attr.close-aria-label]="closeButton ? 'Fechar' : null"
    (b3-close)="close()">
  </b3-modal-header>

  <b3-modal-body>
    <div id="modal-body-content" [innerHTML]="safeContent"></div>
  </b3-modal-body>

  <b3-modal-footer>
    <div *ngIf="modalType === 'confirmation'" class="app-modal-confirmation__footer">
      <b3-button type="button" variant="outlined" tone="default" id="modal_cancel" (b3-click)="close()">
        Não
      </b3-button>
      <b3-button type="button" variant="filled" tone="default" id="btn_confirm_modal" (b3-click)="confirm()">
        Sim
      </b3-button>
    </div>

    <div *ngIf="modalType === 'info' && buttonOk" class="app-modal-confirmation__footer app-modal-confirmation__footer--end">
      <b3-button type="button" variant="filled" tone="default" id="btn_confirm__with_buttonOk_modal" (b3-click)="confirmWithButtonOk()">
        Sim
      </b3-button>
    </div>

    <div *ngIf="modalType === 'info-ok' && buttonOk" class="app-modal-confirmation__footer app-modal-confirmation__footer--end">
      <b3-button type="button" variant="filled" tone="default" id="btn_confirm__with_buttonOk_modal" (b3-click)="confirmWithButtonOk()">
        OK
      </b3-button>
    </div>

    <div
      *ngIf="modalType === 'error' && (supportB3Button || tryAgainButton)"
      class="app-modal-confirmation__footer app-modal-confirmation__footer--end">
      <b3-button
        *ngIf="supportB3Button"
        type="button"
        variant="outlined"
        tone="default"
        (b3-click)="closeToSupport()">
        <b3-icon name="mail" size="md"></b3-icon>
        Suporte B3
      </b3-button>
      <b3-button
        *ngIf="tryAgainButton"
        type="button"
        variant="filled"
        tone="default"
        (b3-click)="close()">
        <b3-icon name="check" size="md" tone="on-brand"></b3-icon>
        Tentar novamente
      </b3-button>
    </div>

    <div
      *ngIf="modalType === 'info' && (newTransferenceButton || operationConsult)"
      class="app-modal-confirmation__footer app-modal-confirmation__footer--end">
      <b3-button
        *ngIf="newTransferenceButton"
        type="button"
        variant="outlined"
        tone="default"
        (b3-click)="close()">
        <b3-icon name="check" size="md"></b3-icon>
        Nova transferência
      </b3-button>
      <b3-button
        *ngIf="operationConsult"
        type="button"
        variant="filled"
        tone="default"
        (b3-click)="confirmWithButtonOk()">
        <b3-icon name="check_circle" size="md" tone="on-brand"></b3-icon>
        Consultar operação
      </b3-button>
    </div>
  </b3-modal-footer>
</b3-modal>
